import Button from "@/common/components/Button";
import { Link } from "react-router-dom";
import { ArrowBigRight } from "lucide-react";
import { Mission } from "../types/mission.type";

type MapToRowsOptions = {
  canShowMission: boolean;
};

export class MissionsTableTransformer {
  static mapToRows(
    missions: Mission[] = [],
    { canShowMission }: MapToRowsOptions,
  ) {
    return missions.map((mission) => {
      const showButton = (
        <Button
          variant="link-white"
          className="p-0"
          operationKlassToCheckPermission="Establishment::Tmais::Missions::Show"
          noPermissionText="Você não tem permissão para acessar"
        >
          <ArrowBigRight />
        </Button>
      );

      return {
        id: mission.id,
        establishment:
          mission.mission_type === "tcard"
            ? "Tcard"
            : mission.establishment?.display_name || "--",
        status: (
          <span className="px-3 py-1 rounded-full text-sm font-semibold text-white">
            {mission.status === "active" ? "Ativa" : "Inativa"}
          </span>
        ),
        name: mission.name,
        start_date: mission.start_date,
        end_date: mission.end_date,
        actions: canShowMission ? (
          <Link to={`/tmais-missions/${mission.id}`}>{showButton}</Link>
        ) : (
          showButton
        ),
      };
    });
  }
}
